module.exports = __webpack_public_path__ + "ace_air_fan_controller.png";